module.exports = __webpack_public_path__ + "static/media/credit-cards-vector-icon-.7dc62c18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/credit-cards-vector-icon-.jpg
// module id = 36
// module chunks = 0